(() => {
  'use strict';
  const loader = document.querySelector('script[data-pstash-corporate-pdf]');
  if (!loader || window.PstashCorporatePdf) return;
  const IMAGE = 'properties[Eigene Druckdatei]';
  const ORIGINAL = 'properties[Original-Druckdatei (PDF)]';
  const TEXT = ['properties[Dein Wunschname 🖊️]', 'properties[Gruß-Überschrift eingeben:]', 'properties[Dein Grußtext 💖:]'];
  let library, generation = 0, blocked = false, originalName = '', originalFile = null;
  const generated = new WeakSet(), bound = new WeakSet(), buttonStates = new Map();
  const api = window.PstashCorporatePdf = { version: '1.0.0', state: 'idle', last: null };
  const input = name => name === ORIGINAL ? document.querySelector('.pplr-wrapper[data-id="Ir3G1OsWl0"] input[type=file]') : [...document.querySelectorAll('input,textarea')].find(el => el.name === name);
  const wrapper = el => el && el.closest('.pplr-wrapper');
  const buttons = () => [...document.querySelectorAll('form[action*="/cart/add"] button[type="submit"],form[action*="/cart/add"] input[type="submit"]')];
  const active = () => { const w = wrapper(input(IMAGE)); return w && w.getBoundingClientRect().height > 0; };
  function guard(value) {
    blocked = value;
    buttons().forEach(button => {
      if (value && active()) {
        if (!buttonStates.has(button)) buttonStates.set(button, button.disabled);
        button.disabled = true;
      } else if (buttonStates.has(button)) {
        button.disabled = buttonStates.get(button); buttonStates.delete(button);
      }
    });
  }
  function message(text, error = false) {
    const w = wrapper(input(IMAGE)); if (!w) return;
    let status = w.querySelector('[data-pstash-pdf-status]');
    if (!status) { status = document.createElement('p'); status.dataset.pstashPdfStatus = ''; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); w.append(status); }
    status.textContent = text; status.classList.toggle('pstash-pdf-error', error);
  }
  function assign(el, file) {
    const transfer = new DataTransfer(); if (file) transfer.items.add(file);
    el.files = transfer.files; el.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function fitArtwork(width, height) {
    const values = window.pplr_values && window.pplr_values[10];
    if (!values || !(width > 0 && height > 0)) return;
    let w = 41.7, h = w * (2835 / 2126) * height / width;
    if (h > 72.2) { w *= 72.2 / h; h = 72.2; }
    values[2] = '50'; values[3] = String((100 - h) / 2);
    values[4] = String(w); values[14] = String(h); values[11] = '0';
  }
  function fitUploadedImage(file) {
    const job = generation, url = URL.createObjectURL(file), image = new Image();
    image.onload = () => {
      if (job === generation && input(IMAGE)) {
        fitArtwork(image.naturalWidth, image.naturalHeight);
        if (window.LoadPplrWithFont) window.LoadPplrWithFont('10', true);
      }
      URL.revokeObjectURL(url);
    };
    image.onerror = () => URL.revokeObjectURL(url); image.src = url;
  }
  function clearOriginal() {
    const field = input(ORIGINAL), w = wrapper(field);
    const remove = w && w.querySelector('.pplr-file-remove,.pplr-remove-file,.pplr_file_remove,.remove,.pplr-remove');
    if (remove) remove.click();
    else if (field) assign(field, null);
    originalName = ''; originalFile = null;
  }
  async function pdf(file, field) {
    const job = ++generation;
    api.state = 'converting'; guard(true); message('PDF wird für die Vorschau vorbereitet …');
    let documentTask, pdfDocument;
    try {
      if (file.size > 10 * 1024 * 1024) throw new Error('Die PDF darf höchstens 10 MB groß sein.');
      if (!library) library = import(loader.dataset.pdfModule).then(module => { module.GlobalWorkerOptions.workerSrc = loader.dataset.pdfWorker; return module; });
      const module = await library;
      documentTask = module.getDocument({ data: new Uint8Array(await file.arrayBuffer()), isEvalSupported: false, enableXfa: false, useSystemFonts: true });
      pdfDocument = await documentTask.promise;
      if (pdfDocument.numPages !== 1) throw new Error('Bitte eine PDF mit genau einer Druckseite hochladen.');
      const page = await pdfDocument.getPage(1), viewport = page.getViewport({ scale: 300 / 72 });
      if (Math.ceil(viewport.width) * Math.ceil(viewport.height) > 20 * 1000 * 1000) throw new Error('Die PDF-Seite ist zu groß. Bitte das Motiv auf die gewünschte Druckfläche begrenzen.');
      const canvas = document.createElement('canvas'); canvas.width = Math.ceil(viewport.width); canvas.height = Math.ceil(viewport.height);
      await page.render({ canvasContext: canvas.getContext('2d'), viewport, background: 'rgba(0,0,0,0)' }).promise;
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
      if (!blob || blob.size > 20 * 1024 * 1024) throw new Error('Die Vorschau ist zu groß. Bitte eine kleinere PDF verwenden.');
      if (job !== generation) return;
      const original = input(ORIGINAL);
      if (!original) throw new Error('Die PDF-Dateiablage ist noch nicht bereit. Bitte erneut versuchen.');
      clearOriginal(); assign(original, file); originalName = file.name; originalFile = file;
      const preview = new File([blob], file.name.replace(/\.pdf$/i, '') + '-vorschau.png', { type: 'image/png' });
      const currentField = input(IMAGE);
      if (!currentField || !currentField.isConnected) throw new Error('Bitte erneut zur Druckdatei wechseln und die PDF hochladen.');
      fitArtwork(canvas.width, canvas.height);
      generated.add(preview); assign(currentField, preview);
      api.last = { original: file.name, preview: preview.name, width: canvas.width, height: canvas.height, dpi: 300, page: 1 };
      api.state = 'ready'; guard(false); message('PDF geladen. Größe und Position jetzt in der Vorschau anpassen.');
    } catch (error) {
      if (job !== generation) return;
      api.state = 'error'; message(error instanceof Error ? error.message : 'PDF konnte nicht gelesen werden.', true); guard(true);
    } finally {
      if (pdfDocument) await pdfDocument.destroy(); else if (documentTask) await documentTask.destroy();
    }
  }
  function install() {
    const field = input(IMAGE), original = input(ORIGINAL);
    if (original && wrapper(original)) wrapper(original).classList.add('pstash-pdf-original');
    if (originalFile && original && active()) {
      const retained = wrapper(original).querySelector('input.pplr-file-input');
      if (retained && !retained.files.length) { const transfer = new DataTransfer(); transfer.items.add(originalFile); retained.files = transfer.files; }
    }
    if (field && !bound.has(field)) {
      bound.add(field); field.accept = '.pdf,application/pdf,image/png,image/jpeg,image/webp,image/svg+xml';
      field.addEventListener('change', event => {
        const file = field.files && field.files[0]; if (!file) return;
        if (file.type === 'application/pdf' || /\.pdf$/i.test(file.name)) { event.stopImmediatePropagation(); event.preventDefault(); void pdf(file, field); }
        else if (!generated.has(file)) { generation++; clearOriginal(); fitUploadedImage(file); api.state = 'ready'; api.last = null; guard(false); message('Motiv geladen. Größe und Position in der Vorschau anpassen.'); }
      }, true);
      const w = wrapper(field);
      if (w && !w.querySelector('[data-pstash-pdf-help]')) { const help = document.createElement('p'); help.dataset.pstashPdfHelp = ''; help.textContent = 'PNG, JPG, SVG oder einseitige PDF. Transparente Motive bewahren den schwarzen Box-Hintergrund.'; w.append(help); }
    }
    TEXT.forEach(name => {
      const el = input(name), w = wrapper(el);
      if (!el || !w || w.querySelector('[data-pstash-clear]')) return;
      const clear = document.createElement('button'); clear.type = 'button'; clear.dataset.pstashClear = ''; clear.className = 'pstash-text-clear'; clear.textContent = 'Text entfernen';
      clear.addEventListener('click', () => { const current = input(name); if (!current) return; current.value = ''; current.dispatchEvent(new Event('input', { bubbles: true })); current.dispatchEvent(new Event('change', { bubbles: true })); }); w.append(clear);
    });
    guard(blocked);
  }
  document.addEventListener('click', event => {
    if (blocked && active() && event.target.closest('form[action*="/cart/add"] button[type="submit"]')) { event.preventDefault(); event.stopImmediatePropagation(); message('Bitte zuerst eine gültige Druckdatei hochladen.', true); }
    const remove = event.target.closest('.pplr_delete,.pplr-remove-file,.pplr_file_remove,.pplr-remove,.pplr-upload-remove');
    if (remove && wrapper(remove) === wrapper(input(IMAGE))) { generation++; clearOriginal(); api.state = 'idle'; api.last = null; guard(false); message('Bitte ein Motiv hochladen.'); }
  }, true);
  document.addEventListener('change', event => {
    if (event.target.name === 'properties[Gestaltung wählen]' && event.target.value === 'Logo & Text gestalten' && api.state === 'converting') {
      generation++; clearOriginal(); api.state = 'idle'; api.last = null; guard(false);
    }
  }, true);
  let scheduled = false;
  const observer = new MutationObserver(() => { if (!scheduled) { scheduled = true; requestAnimationFrame(() => { scheduled = false; install(); }); } });
  observer.observe(document.body, { childList: true, subtree: true }); install();
})();
